import { render } from "./BigIcon.vue?vue&type=template&id=4c41c035"
import script from "./BigIcon.vue?vue&type=script&lang=js"
export * from "./BigIcon.vue?vue&type=script&lang=js"
script.render = render

export default script